import { DesignEventGroups, EstimateEventGroups, PrescriptionEventGroups } from './EventGroups';
import DesignNotificationEvent, { EstimateNotificationEvent, PrescriptionNotificationEvent } from './EventTypeEnum';

enum NotificationServicesEnum {
    System = 1,
    Design,
    Prescription,
    Estimate,
    ProjectManagement,
}

export const RouteNameServiceMap: Record<string, any> = {
    'administration.designing': {
        service: NotificationServicesEnum.Design,
        group: DesignEventGroups,
        events: DesignNotificationEvent,
    },
    'administration.estimate': {
        service: NotificationServicesEnum.Estimate,
        group: EstimateEventGroups,
        events: EstimateNotificationEvent,
    },
    'administration.prescription': {
        service: NotificationServicesEnum.Prescription,
        group: PrescriptionEventGroups,
        events: PrescriptionNotificationEvent,
    },
    'administration.project-management': NotificationServicesEnum.ProjectManagement,
};

export default NotificationServicesEnum;
